import queryString from "query-string";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";
import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "@src/store/slices/global";
import { contactSupport } from "@src/utils/contactSupport";
import { priceFunctionsIntegration } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

export const CompletePricingIntegrationDialog = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("completePricingIntegration"));
  const currentExperience: ExperienceDto | undefined = useSelector(
    getDialogPropDetails("completePricingIntegration")
  );
  const org = useGetOrg();

  const handleDialogClose = () => {
    dispatch(setDialog({ dialog: "completePricingIntegration", open: false }));
  };

  const baseDomain = org.data?.org.domain;
  const currentExperienceId = currentExperience?.id;

  const queryParams = {
    "ig-preview": currentExperienceId,
    "ig-builder-mode": "builder",
    "ig-panel": "price-selectors",
  };

  const queryStringified = queryString.stringify(queryParams);

  const url = `${baseDomain}/?${queryStringified}`;

  const subtitle = (
    <IgTypography>
      It looks like you haven't completed your price testing integration yet. We
      recommend reaching out to our support team at{" "}
      <IgTypography
        onClick={() => {
          contactSupport();
        }}
        igStyle={"link"}
      >
        here{" "}
      </IgTypography>
      for assistance. If you prefer to get started on your own, you can also
      follow our{" "}
      <IgTypography
        onClick={() => {
          openNewTab(priceFunctionsIntegration, "Integration Guide");
        }}
        igStyle={"link"}
      >
        integration guide
      </IgTypography>
      . We're here to help with any questions you may have!
    </IgTypography>
  );

  return (
    <IgDialog
      maxWidth={"sm"}
      padding={"10px 20px 0px 20px"}
      showDialog={isOpen}
      handleClose={handleDialogClose}
      title={"Complete Pricing Integration"}
      subtitle={subtitle}
      yesButtonText={"Tag Your Prices Here"}
      noButtonText={"Cancel"}
      handleNoClick={handleDialogClose}
      handleYesClick={() => {
        window.open(url, "_blank");
        handleDialogClose();
      }}
    />
  );
};
